var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2698_1035",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2698_1035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.75H17.5V7.01906C17.5 6.7949 17.4279 6.61062 17.2838 6.46625C17.1394 6.32208 16.955 6.25 16.7306 6.25H13.2694C13.045 6.25 12.8606 6.32208 12.7163 6.46625C12.5721 6.61062 12.5 6.7949 12.5 7.01906V8.75ZM22.5 27.5C21.1073 27.5 19.9258 27.0148 18.9556 26.0444C17.9852 25.0742 17.5 23.8927 17.5 22.5C17.5 21.1073 17.9852 19.9258 18.9556 18.9556C19.9258 17.9852 21.1073 17.5 22.5 17.5C23.8927 17.5 25.0742 17.9852 26.0444 18.9556C27.0148 19.9258 27.5 21.1073 27.5 22.5C27.5 23.8927 27.0148 25.0742 26.0444 26.0444C25.0742 27.0148 23.8927 27.5 22.5 27.5ZM5.76937 25C5.19396 25 4.71354 24.8073 4.32812 24.4219C3.94271 24.0365 3.75 23.556 3.75 22.9806V10.7694C3.75 10.194 3.94271 9.71354 4.32812 9.32812C4.71354 8.94271 5.19396 8.75 5.76937 8.75H11.25V7.01906C11.25 6.44385 11.4427 5.96354 11.8281 5.57812C12.2135 5.19271 12.694 5 13.2694 5H16.7306C17.306 5 17.7865 5.19271 18.1719 5.57812C18.5573 5.96354 18.75 6.44385 18.75 7.01906V8.75H24.2306C24.806 8.75 25.2865 8.94271 25.6719 9.32812C26.0573 9.71354 26.25 10.194 26.25 10.7694V16.0169C25.681 15.6723 25.0777 15.4167 24.44 15.25C23.8021 15.0833 23.1554 15 22.5 15C20.4198 15 18.6498 15.73 17.19 17.19C15.73 18.6498 15 20.4198 15 22.5C15 22.9215 15.0356 23.3418 15.1069 23.7609C15.1783 24.1799 15.2877 24.5929 15.435 25H5.76937ZM22.5 25.5288C22.6667 25.5288 22.8045 25.4743 22.9134 25.3653C23.0224 25.2564 23.0769 25.1185 23.0769 24.9519C23.0769 24.7852 23.0224 24.6474 22.9134 24.5384C22.8045 24.4295 22.6667 24.375 22.5 24.375C22.3333 24.375 22.1955 24.4295 22.0866 24.5384C21.9776 24.6474 21.9231 24.7852 21.9231 24.9519C21.9231 25.1185 21.9776 25.2564 22.0866 25.3653C22.1955 25.4743 22.3333 25.5288 22.5 25.5288ZM22.0194 23.2213H22.9806V19.4712H22.0194V23.2213Z",
    fill: "#8FDECC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkAlert);
export default __webpack_public_path__ + "static/media/work_alert.bf106599f5c2ed650d0eaa0fff1c2f33.svg";
export { ForwardRef as ReactComponent };